import { CommonModule } from '@angular/common';
import { Component, DestroyRef, OnInit } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';

import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { OrderFilterComponent } from '@b2b/components/order/order-filter/order-filter.component';
import { OrderListComponent } from '@b2b/components/order/order-list/order-list.component';

@Component({
  selector: 'order',
  imports: [CommonModule, RouterModule, OrderFilterComponent, OrderListComponent],
  templateUrl: './cx-order-section.component.html',
})
export class CxOrderSectionComponent implements OnInit {
  path = '';

  constructor(
    private activatedRoute: ActivatedRoute,
    private destroyRef: DestroyRef,
  ) {}

  ngOnInit(): void {
    this.activatedRoute.params.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(params => {
      this.path = params['path'] || '';
    });
  }
}
